<app-menu-toggle
  tooltip="Switch Dark/Light theme"
  [active]="darkTheme"
  icon="dark"
  (click)="setDarkTheme()"
>
</app-menu-toggle>
